import { DataSource, HorizontalSpacer, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiShipMatchCritBilling extends Layout {
    horizontalspacer1: HorizontalSpacer;
    sourceEdiShipmatchCrit: DataSource;
    sourceEdiShipmatchRule: DataSource;
    tableShipMatchRule: Table;
    textboxMatchType: Textbox;
    textboxMaxMoveAge: Textbox;
}
